import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DeviceDTO } from 'src/app/models/DeviceDTO.model';
import { PlanAvailableDTO } from 'src/app/models/PlanAvailableDTO.model';
import { PlanDeviceDTO } from 'src/app/models/PlanDeviceDTO.model';
import { ResponseBase } from 'src/app/models/ResponseBase';
import { TableColumn } from 'src/app/models/TableColumn';
import { UnassignedCustomerDeviceDto } from 'src/app/models/UnassignedCustomerDeviceDto';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { DropdownItem } from 'src/app/shared/controls/dropdown-control/dropdown-control.component';
import { AlertService } from 'src/app/shared/services/alert.service';



import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DropdownControlComponent } from '../../../shared/controls/dropdown-control/dropdown-control.component';
import { TableControlComponent } from '../../../shared/controls/table-control/table-control.component';
declare var bootstrap: any;

@Component({
    selector: 'app-inventory-device-transfers',
    templateUrl: './inventory-device-transfers.component.html',
    styleUrl: './inventory-device-transfers.component.css',
    imports: [
        CommonModule,
        RouterModule,
        DropdownControlComponent,
        TableControlComponent
    ]
})
export class InventoryDeviceTransfersComponent {

  currentStep = 0;
  steps = [
    { label: 'Destination', valid: false },
    { label: 'Devices to Transfer', valid: false },

    { label: 'Review', valid: false }
  ];



  devices: DeviceDTO[] = [];
  devicesList: DeviceDTO[] = [];
  customers: UserDTO[] = [];
  customersDropdownList: DropdownItem[] = [];
  plansAvailables: PlanAvailableDTO[] = [];
  userPlansList: DropdownItem[] = [];
  clearSelection: boolean = false;


  selectedDevices: DeviceDTO[] = [];

  disableCompleteTransferButton: boolean = false;

  columns: TableColumn[] = [
    { key: 'iccid', header: 'ICCID' },
    { key: 'imei', header: 'IMEI' },
    { key: 'firstName', header: 'Last Name' },
    { key: 'lastName', header: 'First Name' },
    { key: 'idAssignedTo', header: 'Assigned To' },
    { key: 'nameStatus', header: 'Status' }
  ]

  selectedCustomer: string | null = null;
  selectedUserPlan: string | null = null;



  /**
   *
   */
  constructor(private customerService: CustomerService, private inventoryService: InventoryService, private alertService: AlertService,) {


  }

  ngOnInit() {

    

    this.inventoryService.getListPlansAvailables().subscribe(
      (response: PlanAvailableDTO[]) => {
        this.plansAvailables = response;
        this.userPlansList = this.plansAvailables.map(plan => ({
          key: plan.userPlanId !== undefined && plan.userPlanId !== null ? plan.userPlanId.toString() : '',
          value: `${plan.nameCustomer} - ${plan.namePlan}`,
        }));
      },
      (error) => {

      }
    );


    this.customerService.GetCustomersForTransfer().subscribe(
      (response: UserDTO[]) => {
        this.customers = response;
        this.customersDropdownList = response.map(customer => ({
          key: customer.userId !== undefined && customer.userId !== null ? customer.userId.toString() : '',
          value: customer.userNames,
        }));
      },
      (error) => {
        // this.alert = {
        //   alertMessage: 'Unexpected error. Please try again later.',
        //   alertType: 'alert alert-danger',
        //   alertCenter: false,
        //   alerTitle: '',
        //   duration: 3000
        // };
        // this.alertService.updateAlertState(
        //   this.alert
        // );
      }
    );
  }

  loadUnassignedDevices(isUserPlan: boolean = true) {
    this.inventoryService.getAllUnassignedDevices(isUserPlan).subscribe(
      (response: DeviceDTO[]) => {
        this.devices = response;
        this.devicesList = response;
      },
      (error: any) => {

      }
    );
  }


  onSelectionChange(selectedDevices: DeviceDTO[]): void {

    this.selectedDevices = selectedDevices;
  }

  onTransferDevices() {
    const transferDeviceModal = new bootstrap.Modal("#transferDeviceModal");
    transferDeviceModal.show();
  }

  transferDeviceModalClose() {
    const transferDeviceModal = new bootstrap.Modal("#transferDeviceModal");
    transferDeviceModal.hide();
  }

  transferDevices() {

    this.disableCompleteTransferButton = true;


    if (this.selectedCustomer) {
      var request: UnassignedCustomerDeviceDto[] = this.selectedDevices.map(device => {
        return {

          userId: this.selectedCustomer ? parseInt(this.selectedCustomer) : null,
          deviceId: device.deviceId!,

        } as UnassignedCustomerDeviceDto;
      });


      this.inventoryService.transferUnassignedCustomerDevices(request).subscribe(
        (data: ResponseBase) => {
          this.clearSteper();
          this.alertService.success('Devices transferred successfully');

        },
        (error: any) => {
          this.alertService.error('Error transferring devices');
        }
      );

    }
    else {
      var request2: PlanDeviceDTO[] = this.selectedDevices.map(device => {
        return {
          aUserPlanId: this.selectedUserPlan ? parseInt(this.selectedUserPlan) : null,
          aDeviceId: device.deviceId,

        } as PlanDeviceDTO;
      });


      this.inventoryService.updatePlanDevicesAsync(request2).subscribe(
        (data: any) => {
          this.clearSteper();
          this.alertService.success('Devices transferred successfully');
        },
        (error) => {
          this.alertService.error('Error transferring devices');
        }
      );
    }
    const transferDeviceModal = new bootstrap.Modal("#transferDeviceModal");
    transferDeviceModal.hide();
  }

  get reviewInfoMessage() {




    if (this.selectedCustomer) {

      var customer = this.customers.find(c => c.userId === parseInt(this.selectedCustomer as string));

      return `to the customer: ${customer?.userNames}`;


    }
    if (this.selectedUserPlan) {

      var userPlan = this.plansAvailables.find(p => p.userPlanId === parseInt(this.selectedUserPlan as string))
      return `to the customer plan: ${userPlan?.nameCustomer} - ${userPlan?.namePlan}`;


    }


    return '';
  }

  clearSteper() {
    this.devices = [];

    this.selectedCustomer = null;
    this.selectedUserPlan = null;
    this.selectedDevices = [];
    this.currentStep = 0;



    this.clearSelection = true;

    setTimeout(() => this.clearSelection = false);
  }

  onCustomerChange(event: any) {

    this.selectedCustomer = event.key;
    this.selectedUserPlan = null;
    this.isCurrentStepValid();

    this.loadUnassignedDevices(false);

  }

  onUserPlanChange(event: any) {

    this.selectedUserPlan = event.key;
    this.selectedCustomer = null;

    if (this.selectedUserPlan !== null) {
      var plan = this.plansAvailables.find(plan => plan.userPlanId === parseInt(this.selectedUserPlan as string));
      this.devicesList = this.devices.filter(device => {
        return plan?.carriers?.includes(device.carrierName as string);
      });

    }

    this.isCurrentStepValid();
    this.loadUnassignedDevices(true);

  }

  get progressPercentage(): number {
    return (this.currentStep / (this.steps.length - 1)) * 100;
  }

  nextStep(): void {
    if (this.isCurrentStepValid()) {
      this.steps[this.currentStep].valid = true;
      this.currentStep++;
    }
  }

  previousStep(): void {
    this.currentStep--;
  }

  isCurrentStepValid(): boolean {
    switch (this.currentStep) {
      case 0:
        if (this.selectedCustomer || this.selectedUserPlan) {
          return true;
        }
        return false;

      case 1:
        return this.selectedDevices.length > 0;
      default:
        return true;
    }
  }





}
